"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createAction;

var _isFunction = _interopRequireDefault(require("./isFunction"));

function createAction(type, actionCreator, metaCreator) {
  return function () {
    var action = {
      type: type
    };

    if ((0, _isFunction.default)(actionCreator)) {
      action.payload = actionCreator.apply(void 0, arguments);
    }

    if ((0, _isFunction.default)(metaCreator)) {
      action.meta = metaCreator.apply(void 0, arguments);
    }

    return action;
  };
}

module.exports = exports.default;